import React, {useEffect, useState} from 'react';
import styled, {keyframes} from 'styled-components'
import 'normalize.css';
import 'animate.css';
import {GlobalStyles, Typography} from '../styles';
import bg from '../assets/img/bg.png';
import Header from './Header';
import Footer from './Footer';
import {breakPoint} from '../styles/var';

const ContentStyled = styled.div`
  background: white url(${bg}) repeat left top;
  background-size: 14rem;
  min-height: 100vh;

  &.load {
    opacity: 0;
    height: 100vh;
    overflow: hidden;
  }
  @media (max-width: ${breakPoint.smMax}) {
    background-size: 9rem;
  }
`;

const loadingAnimation = keyframes`
  0% {
    opacity: 0
  }
  100% {
    opacity: 1
  }
`;

const LoadingStyled = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  .letter {
    animation: ${loadingAnimation} 0.48s infinite linear;
  }

  .s2 {
    animation-delay: .6s;
  }

  .s3 {
    animation-delay: .72s;
  }
`

const Layout = ({children, ...props}) => {
  const [contentClass, setContentClass] = useState('load');

  useEffect(() => {
    setTimeout(() => {
      setContentClass('');
    }, 1000);
  }, []);

  return (
    <>
      <GlobalStyles/>
      <Typography/>
      <ContentStyled className={contentClass}>
        <Header/>
        {children}
        <Footer/>
      </ContentStyled>
      {
        contentClass && (
          <LoadingStyled>loading
            <span className="s1 letter">.</span>
            <span className="s2 letter">.</span>
            <span className="s3 letter">.</span>
          </LoadingStyled>
        )
      }
    </>
  )
}

export default Layout;
